import React from 'react'
import './circle.css'
const Circle = ({ value, size = '40px', fontSize = '16px' }) => {
  return (
    <div className='circle' style={{ height: size, width: size, fontSize }}>{value}</div>
  )
}

export default Circle